import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/vercel/path0/apps/web/app/sentry/SentryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/modules/ui/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["TolgeeNextProvider"] */ "/vercel/path0/apps/web/tolgee/client.tsx");
